uniform sampler2D uPerlintexture;
uniform float uTime;

varying vec2 vUv;

void main(){

    vec2 smokeUv = vUv;
    smokeUv.x *= 0.6;
    smokeUv.y *= 0.3;
    smokeUv.y -= uTime * 0.03;

    //remap
    float smoke = texture(uPerlintexture, smokeUv).r;
    smoke = smoothstep(0.1, 0.8, smoke);

    //edges

    smoke *= smoothstep(0.0, 0.1, vUv.x);
   smoke *= smoothstep(1.0, 0.1, vUv.x);
    smoke *= smoothstep(0.0, 0.1, vUv.y);
    smoke *= smoothstep(1.0, 0.4, vUv.y);

    gl_FragColor = vec4(0.85, 0.78, 0.70, smoke);
    
    #include <colorspace_fragment>
}